export const analyticsData = {
    analyticsDataContent: {
        mainHeading: "Specialized for Analytics Solutions Your",
        greenHeading: "Industry Needs",
        sectionDescription: "We understand that each industry has unique challenges & opportunities. That’s why we offer industry-specific analytics solutions designed to address your most pressing needs.",
        buttonText: "Explore all Industries"
    },
    analyticsDataCards: [
        {
            title: "CRM Analytics",
            description: "Our CRM analytics solutions provide deep insights into customer interactions, helping you optimize customer relationships, improve retention rates, & enhance overall satisfaction.",
            icon: 'CRM.png'
        },
        {
            title: "Customer Analytics",
            description: "We analyze customer behavior to help you understand preferences, predict trends, & personalize experiences, leading to increased loyalty & higher conversion rates.",
            icon: 'Customer-ANALYTICS.png'
        },
        {
            title: "Financial Risk Assessment",
            description: "Our HR analytics solutions offer valuable insights into workforce management, enabling you to improve recruitment, optimize employee performance, & reduce turnover.",
            icon: 'RISK-ASSESMENTS.png'
        },
        {
            title: "HR Analytics",
            description: "Leverage our sales analytics to identify trends, forecast sales, & optimize your sales strategies, ensuring you hit your targets & drive revenue growth.",
            icon: 'HR-ANALYTICS.png'
        },
        {
            title: "Sales Analytics",
            description: "We provide comprehensive marketing analytics to track campaign performance, understand customer journeys, & optimize your marketing efforts for maximum ROI.",
            icon: 'SALES-ANALYTICS.png'
        },
        {
            title: "Predictive Analytics",
            description: "Our supply chain analytics solutions enhance operational efficiency by providing insights into inventory management, demand forecasting, & logistics optimization.",
            icon: 'PREDICTIVE-ANALYSIS.png'
        },
        {
            title: "Marketing Analytics",
            description: "We help you assess & manage financial risks with our advanced analytics, enabling better decision-making & ensuring financial stability.",
            icon: 'MARKETING-ANALYTICS.png'
        },
        {
            title: "Supply Chain Analytics",
            description: "Our predictive analytics solutions allow you to anticipate market changes, optimize strategies, & make proactive decisions that keep you ahead of the competition.",
            icon: 'SUPPLY-CHAIN-ANALYTICS.png'
        }
    ]
}